import { createServerFn } from "@tanstack/react-start";

import type { UserSelect } from "~/../drizzle/schema";
import { clearAnonUserIdCookie } from "~/lib/cookies";

export interface AuthRequestStateNotSignedIn {
  isSignedIn: false;
}

export interface AuthRequestStateSignedIn {
  isSignedIn: true;
  user: UserSelect;
}

export type AuthRequestState =
  | AuthRequestStateNotSignedIn
  | AuthRequestStateSignedIn;

export function setAuthRequestState(
  sharedMap: Map<string, unknown>,
  state: AuthRequestState,
): void {
  sharedMap.set("auth", state);
}

export function getAuthRequestState(
  sharedMap: Map<string, unknown>,
): AuthRequestState {
  return (sharedMap.get("auth") ?? { isSignedIn: false }) as AuthRequestState;
}

export const signOut = createServerFn({ method: "POST" }).handler(async () => {
  const { auth } = await import("@clerk/tanstack-react-start/server");
  const authState = await auth();

  if (authState.sessionId) {
    const clerkClient = await resolveClerkClient();
    await clerkClient.sessions.revokeSession(authState.sessionId);
  }

  clearAnonUserIdCookie();

  return { success: true } as const;
});

async function resolveClerkClient() {
  const { initializeClerkIfNeeded, getClerk } =
    await import("./server/clerk-server");
  await initializeClerkIfNeeded();
  return getClerk();
}
